import React from "react";

const AboutBanner = () => {
  return (
    <div className="about-banner-section">
      <div className="container">
        <h2>About</h2>
        <p className="subtitle">Our journey to simplify and enhance business connections for everyone.</p>
        <div className="banner-image-container">
        </div>
      </div>
    </div>
  );
};

export default AboutBanner;
